import { render, staticRenderFns } from "./RxTextarea.vue?vue&type=template&id=5689d12c"
import script from "./RxTextarea.vue?vue&type=script&lang=js"
export * from "./RxTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports